import { ReactElement, useCallback } from 'react';
import { Stack } from '@mui/material';
import { TableChangeHandler } from 'react-bootstrap-table-next';

import { DataTable, DialogDetailsOrder } from '~components/index';

import { useDashboardVariantV2GiverContentInTransitTabContext } from '../../Context';

import { ITEM_KEY_ID } from '../../utils';
import { DashboardVariantV2GiverContentDataTableContainer } from '../../../../styles';

import { useInTransitTabDataTableColumns } from './useColumns';

const DashboardVariantV2GiverContentInTransitTabDataTable =
  (): ReactElement => {
    const {
      table: {
        data,
        loading: loadingRequestTable,
        totalSize,
        queryParams: { pagination },
        handleChangeTable: changeTable,
      },
      dialogs: {
        detailsOrder: {
          open: openDialogDetailsOrder,
          data: selectedDataForDetailsOrder,
          handleClose: handleCloseDialogDetailsOrder,
        },
      },
    } = useDashboardVariantV2GiverContentInTransitTabContext();

    const columns = useInTransitTabDataTableColumns();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChangeTable = useCallback<TableChangeHandler<any>>(
      (type, newState) => {
        changeTable(type, {
          pagination: { ...newState, sortField: newState?.sortField },
        });
      },
      [changeTable],
    );

    return (
      <>
        <Stack>
          <DashboardVariantV2GiverContentDataTableContainer>
            <DataTable
              loading={loadingRequestTable}
              data={data}
              columns={columns}
              keyField={ITEM_KEY_ID}
              pagination={{
                options: {
                  sizePerPage: pagination.sizePerPage,
                  page: pagination.page,
                  totalSize,
                },
              }}
              remote={{
                pagination: true,
                sort: true,
              }}
              onTableChange={handleChangeTable}
              hideableStorageKey="Dashboard-Giver-In-Transit-Data-Table"
              toggleHideableColumns
              excludeHideableFieldColumns={['title']}
            />
          </DashboardVariantV2GiverContentDataTableContainer>
        </Stack>

        {openDialogDetailsOrder && selectedDataForDetailsOrder && (
          <DialogDetailsOrder
            open={openDialogDetailsOrder}
            onClose={handleCloseDialogDetailsOrder}
            enabledChipTitle={false}
            {...selectedDataForDetailsOrder}
          />
        )}
      </>
    );
  };

export default DashboardVariantV2GiverContentInTransitTabDataTable;
